// Back shows the page as it is now (NFR-SEC-03). Specter's pages are served
// `Cache-Control: no-store`, so Back fetches them again: a vote just cast
// shows on the dashboard Back returns to, and a browser signed out shows
// no page it kept. A browser that keeps such a page in its back/forward
// cache all the same restores it as it was; that page loads again, once.
window.addEventListener("pageshow", (event) => {
  if (event.persisted) window.location.reload();
});
